import _ from 'lodash'
import cx from 'classnames'
import {
  PROPOSAL_PHASE_TYPE,
  PROPOSAL_TYPE
} from '@vzmi/shp_shared_compo/constants/proposal'
import { ERROR } from '../../../../../constants/globalTypes'
import { PROPOSAL_TYPE_NAME } from '../../../../../constants/proposalTypes'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { HyperLink } from '../../../../Common/Form'
import PrefixBlock from '../../PrefixBlock'

export const getDuplicatedSkuInSpecsList = models => {
  const modelItems = _.flow(
    // 取出全部第二層數性 [[{ sku: 123 }, { sku: 456 }], [{ sku: 123 }]]
    () => _.map(models, model => {
      const modelItems = _.get(model, 'items', [])
      return [
        ..._.map(modelItems, modelItem => ({ ...modelItem, parent: model })),
        model
      ]
    }),
    // 攤平第二層屬性 [{ sku: 123 }, { sku: 456 }, { sku: 123 }]
    modelItemsList => _.concat(...modelItemsList)
  )()
  const duplicatedSkuMap = _.flow(
    // 按照 sku 加總 { 123: 2, 456: 1 }
    () => _.countBy(modelItems, 'sku'),
    // 過濾掉加總沒有重複的 sku
    countedSkuMap => _.reduce(countedSkuMap, (map, count, sku) => {
      if (count > 1) {
        map[sku] = count
      }
      return map
    }, {}),
    map => _.omit(map, ['undefined'])
  )()
  const duplicatedSkuInSpecsList = _.reduce(duplicatedSkuMap, (list, count, sku) => {
    const duplicatedItem = {
      sku,
      specNames: _.flow(
        () => _.filter(modelItems, modelItem => `${modelItem.sku}` === `${sku}`),
        filteredModelItems => _.map(filteredModelItems, filteredModelItem => {
          return `「${_.get(filteredModelItem, 'spec.selectedValue')}」`
        })
      )()
    }
    list.push(duplicatedItem)
    return list
  }, [])
  return duplicatedSkuInSpecsList
}

export const getDuplicatedSkuInSpecsMessage = duplicatedSkuInSpecsList => {
  const duplicatedSkuInSpecsMessage = _.flow(
    () => _.map(duplicatedSkuInSpecsList, ({ sku, specNames }) => {
      return `商品 ${sku} 同時存在於屬性項目${_.join(specNames, '、')}`
    }),
    duplicatedMessages => _.join(duplicatedMessages, '；')
  )()
  return duplicatedSkuInSpecsMessage
}

const DuplicatedPrefixBlock = props => {
  const {
    proposalType,
    duplicatedMap,
    listing,
    isSingleUpdate = false
  } = props

  const listingId = _.get(listing, 'id')
  const models = _.get(listing, 'models', [])
  const duplicatedSkuInSpecsList = getDuplicatedSkuInSpecsList(models)
  const isDuplicatedSkuInSpecsListExist = !_.isEmpty(duplicatedSkuInSpecsList)
  if (isDuplicatedSkuInSpecsListExist) {
    // 單筆系列 /proposal/updatexxx
    // 批次系列 /proposal/batch/updatexxx
    const helpLink = `${isSingleUpdate ? '' : '../'}../${PROPOSAL_TYPE.UPDATE_LISTING_MODEL}/${PROPOSAL_PHASE_TYPE.COMPOSE}`
    return (
      <PrefixBlock
        type={ERROR}
        className={cx(
          'has-form-error',
          'duplicatedSkus'
        )}
      >
        {getDuplicatedSkuInSpecsMessage(duplicatedSkuInSpecsList)}
        ，無法進行修改，可至「
        <HyperLink
          href={`${helpLink}?listingId=${listingId}`}
          target='_blank'
        >
          調整賣場屬性
        </HyperLink>
        」進行調整後修改圖片。
      </PrefixBlock>
    )
  }

  const duplicatedList = _.get(duplicatedMap, listingId, [])
  const isDuplicatedListExist = !_.isEmpty(duplicatedList)
  if (!isDuplicatedListExist) {
    return null
  }

  const url = `/proposal/${proposalType}/${PROPOSAL_PHASE_TYPE.COMPOSE}`
  const duplicatedSkuLastIndex = _.size(duplicatedList) - 1

  return (
    <PrefixBlock
      type={ERROR}
      className='duplicated'
    >
      {duplicatedList.map(({ sku, listings }, skuIndex) => {
        const idsStr = _.flow(
          () => _.map(listings, 'id'),
          ids => _.join(ids, `${COMMA} `)
        )()
        return (
          <span key={sku}>
            {`商品 ${sku} 與賣場 ${idsStr} 共用`}
            {duplicatedSkuLastIndex !== skuIndex && ' | '}
          </span>
        )
      })}
      <p>
        含有共用商品的賣場無法一起修改，您可移除其他賣場或者使用單筆
        <HyperLink
          target='_blank'
          href={`${url}?listingId=${listingId}`}
        >
          {PROPOSAL_TYPE_NAME[proposalType]}
        </HyperLink>
      </p>
    </PrefixBlock>
  )
}

export default DuplicatedPrefixBlock
